<template>
  <div v-if="this.deudores">
    <h4>Saldos</h4>

    <p><b>Saldo total:</b> {{ saldoTotal }} €</p>

    <table id="tabla-saldos" class="table table-bordered table-striped table-hover">
      <thead>
        <tr>
          <th>Socio</th>
          <th>Titular</th>
          <th>Saldo</th>
          <th>Estado</th>
          <th>Inicio impago</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="d in deudores" :key="d.id_familia" class="fila-familia" @click="abrirFamilia(d.id_familia)" @click.middle="abrirFamiliaTab(d.id_familia)">
          <td>{{ d.num_socio }}</td>
          <td>{{ d.titular }}</td>
          <td>{{ d.saldo }}</td>
          <td v-if="d.impago">IMPAGO</td>
          <td v-else>-</td>
          <td v-if="d.fecha_impago">{{ d.fecha_impago | ts_dia }}</td>
          <td v-else>-</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>

import { api } from '../api/api.js';

export default {
	name: 'AdminSaldos',
	data () {
		return {
			deudores: null,
			saldoTotal: null,
		}
	},
	created () {
        this.obtenerSaldos();
	},
	methods: {
		obtenerSaldos() {
			api(`/tesoreria/saldos`)
				.then((data) => {
					this.saldoTotal = data.resultado.saldo_total;
					// Apaño mientras no implemento datatables en esta vista
					data.resultado.deudores.sort((a, b) => { return a.saldo - b.saldo });
					this.deudores = data.resultado.deudores;
				});
		},
		abrirFamilia(id_familia) {
			this.$router.push('/admin/familia/' + id_familia);
		},
		abrirFamiliaTab(id_familia) {
			window.open('/admin/familia/' + id_familia);
		},
	},
	filters: {
		ts_dia(timestamp) {
			const d = new Date(timestamp * 1000);
			return `${d.getDate()}/${d.getMonth()+1}/${d.getFullYear()}`;
		}
	}
}
</script>
